import type { BaseLeadsSearchRow, LeadsSearchRow } from "../types/rows";

import type { LeadsType } from "./tabbed-results";

export const isLeadsType = (value: unknown): value is LeadsType => {
    return value === "companies" || value === "websites";
};

export const leadRowTypeGuard = {
    isWebsiteLeadRow<R extends BaseLeadsSearchRow>(
        row: R | undefined = {} as R,
    ): row is R & Required<Pick<LeadsSearchRow, "site">> {
        return "site" in row;
    },

    isCompanyLeadRow<R extends BaseLeadsSearchRow>(
        row: R | undefined = {} as R,
    ): row is R & Required<Pick<LeadsSearchRow, "company" | "company_domains">> {
        return "company" in row && "company_domains" in row;
    },
};
